export const BENCHMARK_DOWNLOAD_EXCEL_DROPDOWN_URL = "/api/benchmark/engagement/trafficShare/excel";
